import { Box, withTheme } from '@material-ui/core';
import styled from 'styled-components';

export default withTheme(styled(Box)`
  > h6 {
    margin: 20px 0;
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    ${({ theme }) => `${theme.breakpoints.down('sm')} {
      font-size: 95%;
      margin: 10px 0 0;
    }`};
  }
  > .MuiChip-root {
    margin: 20px 0;
    ${({ theme }) => `${theme.breakpoints.down('sm')} {
      margin-bottom: 10px;
    }`};
  }
  > .MuiGrid-root {
    margin-bottom: 20px;
    ${({ theme }) => `${theme.breakpoints.down('sm')} {
      font-size: 95%;
      margin-bottom: 0;
    }`};
  }
  > .MuiGrid-root > .MuiGrid-item {
    ${({ theme }) => `${theme.breakpoints.down('sm')} {
      padding-bottom: 0;
    }`};
  }
`);
